import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Reports from "../../common/reports/Reports";
import GlobalContext from "../../framework/GlobalContext";
import classes from "./StockTransferReport.module.css";
import StockTransferReportFilter from "./StockTransferReportFilter";
import Button from "../../framework/Button";
import Shortcut from "../../framework/Shortcut";
import StockTransferDetails from "./stockTransferDetails";
import Autocomplete from "../../framework/Autocomplete";
import StockTransferReportSummary from "./StockTransferReportSummary";

const StockTransferReport = () => {
  const [onFilterShow, setOnFilterShow] = useState(false);
  const [onColumnShow, setOnColumnShow] = useState(false);
  const [rowLevelCTAs, setRowLevelCTAs] = useState([]);
  const [filterParams, setFilterParams] = useState(null);
  const [filterStates, setFilterStates] = useState(null);
  const [currentRowData, setCurrentRowData] = useState(null);
  const [showStockTransferDetails, setShowStockTransferDetails] =
    useState(false);
  const { currentComponent, setCurrentComponent } = useContext(GlobalContext);
  const reportRef = useRef();
  const refreshRef = useRef();
  const enterRef = useRef();
  const exportRef = useRef();

  const refreshData = useCallback((filterData = {}) => {
    reportRef.current.applyFilters(filterData);
  }, []);

  const applyFilterHandler = useCallback((params, filterStates) => {
    setFilterParams(params);
    setFilterStates(filterStates);
  }, []);
  const quickExportHandler = () => {
    reportRef?.current?.quickExport({ fileName: "StockTransferReport" });
  };
  const closeStockTransferDetails = useCallback(() => {
    setShowStockTransferDetails(false);
    setCurrentComponent("grid_reports");
    refreshRef.current.click();
  }, [setCurrentComponent]);
  const listener = useCallback((e) => {
    const key = e.key?.toLowerCase();
    const ctrlKey = e.ctrlKey;
    const altKey = e.altKey;
    if (altKey && key === "r") {
      refreshRef.current.click();
      return;
    }
    if (ctrlKey && key === "i") {
      enterRef.current.click();
      return;
    }
    if (key === "enter") {
      enterRef.current.click();
      return;
    }
  }, []);
  useEffect(() => {
    const allRowCTAs = [
      <Button
        ref={enterRef}
        startIcon={
          <>
            <Shortcut keys={["Enter"]} />/<Shortcut keys={["Ctrl", "I"]} />
          </>
        }
        label="info"
        onClick={() => {
          setShowStockTransferDetails(true);
        }}
        isAccessible={currentRowData}
      />,
    ];
    setRowLevelCTAs(allRowCTAs);
  }, [currentRowData]);
  useEffect(() => {
    if (!onFilterShow && !onColumnShow && currentComponent === "grid_reports") {
      document.addEventListener("keyup", listener, false);
    }
    return () => {
      document.removeEventListener("keyup", listener, false);
    };
  }, [currentComponent, listener, onColumnShow, onFilterShow]);
  useEffect(() => {
    refreshData({ isFilterChanged: true, ...filterStates });
  }, [refreshData, filterStates]);
  return (
    <div className={classes["stock-transfer-report-container"]}>
      <Reports
        identifier="stockTransferReport"
        reportRef={reportRef}
        rowLevelCTAs={rowLevelCTAs}
        filterStates={filterStates}
        filterParams={filterParams}
        onFilterShowClick={setOnFilterShow}
        onColumnShowClick={setOnColumnShow}
        currentRow={setCurrentRowData}
        onCellClicked={(params) => {
          if (params.column.colId === "stockTransferId") {
            if (params.data.stockTransferId) setShowStockTransferDetails(true);
          }
        }}
        filters={
          <StockTransferReportFilter
            reportRef={reportRef}
            filters={(filters) => {
              setFilterStates(filters);
            }}
            onFilterShow={onFilterShow}
            refreshData={refreshData}
            applyFilters={applyFilterHandler}
          />
        }
      />
      <Autocomplete
        show={showStockTransferDetails}
        height="60%"
        closeAutoComplete={closeStockTransferDetails}
      >
        <StockTransferDetails
          stockTransferId={currentRowData?.data?._id}
          onEscape={closeStockTransferDetails}
        />
      </Autocomplete>
      <StockTransferReportSummary
        refreshData={refreshData}
        refreshRef={refreshRef}
        quickExport={quickExportHandler}
        exportRef={exportRef}
      />
    </div>
  );
};

export default StockTransferReport;
